import { benefitsService } from '@/services/benefits.service'
import type { BenefitsStatus, ElectionChoice, VerifyPayload } from '@/services/benefits.service'
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'

export const benefitsKeys = {
  all: ['benefits'] as const,
  status: () => [...benefitsKeys.all, 'status'] as const,
}

export function useBenefitsStatus(enabled = true) {
  return useQuery({
    queryKey: benefitsKeys.status(),
    queryFn: () => benefitsService.getStatus(),
    enabled,
  })
}

export function useDecisionAid(enabled = true) {
  return useQuery({
    queryKey: [...benefitsKeys.status(), 'decision-aid'],
    queryFn: () => benefitsService.getDecisionAid(),
    enabled,
  })
}

export function useReportReemployment() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: () => benefitsService.reportReemployment(),
    // Refetch rather than patching the cache: reporting can also move the
    // election's status, and the server is the authority on what it became.
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: benefitsKeys.status() })
    },
  })
}

export function useSubmitElection() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (choice: ElectionChoice) => benefitsService.submitElection(choice),
    onSuccess: (data: BenefitsStatus) => {
      queryClient.setQueryData(benefitsKeys.status(), data)
    },
  })
}

export function useVerifyBenefits() {
  return useMutation({
    mutationFn: (payload: VerifyPayload) => benefitsService.verify(payload),
  })
}
